import { FIELD_TYPE } from "@saleor/components/FormField/constants";
import useThailandAddress from "@saleor/createOrChangeNotRefContract/hooks/useThailandAddress";
import { useGetCountryMasterDataLazyQuery } from "@saleor/graphql";
import React, { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";

import useStyles from "./styles";
const useOneTimeForms = formik => {
  const intl = useIntl();
  const classes = useStyles();
  const {
    subDistrict,
    district,
    city,
    zipCode,
    selectedZipCode
  } = useThailandAddress(formik);

  const [
    getCountryList,
    { data: countryCodeNameList }
  ] = useGetCountryMasterDataLazyQuery({ fetchPolicy: "no-cache" });
  useEffect(() => {
    getCountryList();
  }, []);

  const isDisableFiled = fieldvalue => {
    if (fieldvalue?.length === 0 || fieldvalue === null) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const selectedCountry = countryCodeNameList?.getCountryMasterData.find(
      item => item.countryCode === formik?.values?.countryCode
    );

    if (selectedCountry) {
      formik.setFieldValue(
        "countryName",
        selectedCountry?.countryName?.toUpperCase()
      );
    }
  }, [formik?.values?.countryCode, countryCodeNameList]);

  const countryList =
    countryCodeNameList?.getCountryMasterData?.map(item => ({
      label: `${item?.countryCode} - ${item?.countryName?.toUpperCase()}`,
      value: item?.countryCode
    })) || [];

  const languageList = [
    {
      value: "th",
      label: "TH"
    },
    { value: "en", label: "EN" }
  ];

  const isOtherCountry = formik?.values?.countryCode !== "TH";

  const cityPlaceHolder = isOtherCountry
    ? intl.formatMessage({ defaultMessage: "ระบุ City" })
    : intl.formatMessage({ defaultMessage: "เลือกจังหวัด" });

  const postalCodePlaceHolder = isOtherCountry
    ? intl.formatMessage({
        defaultMessage: "ระบุ Postal Code"
      })
    : intl.formatMessage({
        defaultMessage: "รหัสไปรษณีย์"
      });

  const formOneTimeShipTo = useMemo(
    () => [
      {
        title: intl.formatMessage({ defaultMessage: "Cust. Code" }),
        name: "soldToCode",
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        isDisabled: true
      },
      {
        title: intl.formatMessage({ defaultMessage: "Cust. Name" }),
        name: "name1",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "ระบุชื่อลูกค้า หรือ ชื่อบริษัท"
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        hint:
          formik.values.name1.length > 0 ? (
            <div
              style={{
                textAlign: "end",
                color: "#696969",
                marginRight: "-14px",
                marginBottom: "-22px"
              }}
            >{`${formik?.values?.name1?.length || 0}/70`}</div>
          ) : null,
        maxLength: 70
      },
      {
        type: "Headers",
        title: "Address"
      },
      {
        type: "Button",
        title: intl.formatMessage({
          defaultMessage: "ค้นหาข้อมูล ผู้จดทะเบียนภาษีมูลค่าเพิ่ม"
        })
      },
      {
        title: intl.formatMessage({ defaultMessage: "Country" }),
        name: "countryCode",
        required: true,
        type: FIELD_TYPE.SINGLE_SELECT,
        options: countryList,
        md: 2,
        labelParser: value => {
          if (typeof value === "string") {
            return value.split("-")[0].trim();
          } else {
            return value;
          }
        }
      },
      {
        name: "countryName",
        type: FIELD_TYPE.SINGLE_INPUT,
        isDisabled: true,
        md: 4
      },
      {
        title: intl.formatMessage({ defaultMessage: "Transportation Zone" }),
        name: "transportationZone",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือก Transportation Zone"
        }),
        type: "transportationZone",
        options: countryList,
        md: 6
      },
      {
        title: intl.formatMessage({ defaultMessage: "Street Address" }),
        name: "street1",
        placeholder: intl.formatMessage({
          defaultMessage: "ระบุที่อยู่"
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        className: classes.street0,
        hint: (
          <div
            style={{ textAlign: "end", color: "#696969", marginRight: "-14px" }}
          >{`${formik?.values?.street1?.length || 0}/80`}</div>
        ),
        maxLength: 80
      },
      {
        title: intl.formatMessage({ defaultMessage: "  " }),
        name: "street2",
        placeholder: intl.formatMessage({
          defaultMessage: "ระบุที่อยู่"
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        className: classes.street1,
        hint: (
          <div
            style={{
              textAlign: "end",
              color: "#696969",
              marginRight: "-14px",
              marginBottom: "-14px"
            }}
          >{`${formik?.values?.street2?.length || 0}/80`}</div>
        ),
        maxLength: 80
      },
      {
        title: isOtherCountry
          ? "City"
          : intl.formatMessage({ defaultMessage: "จังหวัด" }),
        name: "city",
        required: true,
        placeholder: cityPlaceHolder,
        type: isOtherCountry
          ? FIELD_TYPE.SINGLE_INPUT
          : FIELD_TYPE.SINGLE_SELECT,
        options: city,
        md: 6,
        isDisabled: isDisableFiled(city),
        maxLength: 40
      },
      {
        title: intl.formatMessage({ defaultMessage: "เขต/อำเภอ" }),
        name: "district",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือกเขต/อำเภอ"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: district,
        md: 6,
        isDisabled: isDisableFiled(district),
        hideField: isOtherCountry
      },
      {
        title: intl.formatMessage({ defaultMessage: "แขวง/ตำบล" }),
        name: "subDistrict",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือกแขวง/ตำบล"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: subDistrict,
        md: 6,
        isDisabled: isDisableFiled(subDistrict),
        hideField: isOtherCountry
      },

      {
        title: isOtherCountry
          ? "Postal Code"
          : intl.formatMessage({ defaultMessage: "รหัสไปรษณีย์" }),
        name: "postalCode",
        placeholder: postalCodePlaceHolder,
        type: isOtherCountry
          ? FIELD_TYPE.SINGLE_INPUT
          : FIELD_TYPE.SINGLE_SELECT,
        options: zipCode,
        md: 6,
        isDisabled: isOtherCountry ? false : isDisableFiled(selectedZipCode),
        maxLength: 10
      },
      { type: "Headers", title: "Communication" },
      {
        title: intl.formatMessage({ defaultMessage: "Language" }),
        name: "language",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: languageList,
        md: 3
      },

      {
        title: intl.formatMessage({ defaultMessage: "Mobile Number" }),
        name: "mobileNo",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 6,
        maxLength: 30
      },
      {
        title: intl.formatMessage({ defaultMessage: "Telephone No." }),
        name: "telephoneNo",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 4,
        maxLength: 30,
        className: classes.mobileFax
      },
      {
        title: intl.formatMessage({ defaultMessage: "Extension" }),
        name: "telephoneExtension",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.NUMBER_INPUT,
        md: 2,
        nonBold: true,
        maxLength: 5
      },
      {
        title: intl.formatMessage({ defaultMessage: "Fax" }),
        name: "faxNo",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.NUMBER_INPUT,
        md: 4,
        maxLength: 30,
        className: classes.mobileFax
      },
      {
        title: intl.formatMessage({ defaultMessage: "Extension" }),
        name: "faxNoExt",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.NUMBER_INPUT,
        md: 2,
        nonBold: true,
        maxLength: 5
      }
    ],
    [subDistrict, district, city, zipCode, selectedZipCode]
  );

  const formOneTimeBillTo = useMemo(
    () => [
      {
        title: intl.formatMessage({ defaultMessage: "Cust. Code" }),
        name: "soldToCode",
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        isDisabled: true
      },
      {
        title: intl.formatMessage({ defaultMessage: "Cust. Name" }),
        name: "name1",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "ระบุชื่อลูกค้า หรือ ชื่อบริษัท"
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        hint:
          formik.values.name1.length > 0 ? (
            <div
              style={{
                textAlign: "end",
                color: "#696969",
                marginRight: "-14px",
                marginBottom: "-22px"
              }}
            >{`${formik?.values?.name1?.length || 0}/70`}</div>
          ) : null,
        maxLength: 70
      },

      { type: "Headers", title: "Address" },
      {
        type: "Button",
        title: intl.formatMessage({
          defaultMessage: "ค้นหาข้อมูล ผู้จดทะเบียนภาษีมูลค่าเพิ่ม"
        })
      },
      {
        title: intl.formatMessage({ defaultMessage: "Country" }),
        name: "countryCode",
        required: true,
        type: FIELD_TYPE.SINGLE_SELECT,
        options: countryList,
        md: 2,
        labelParser: value => {
          if (typeof value === "string") {
            return value.split("-")[0].trim();
          } else {
            return value;
          }
        }
      },
      {
        name: "countryName",
        type: FIELD_TYPE.SINGLE_INPUT,
        isDisabled: true,
        md: 10
      },
      {
        title: intl.formatMessage({ defaultMessage: "Street Address" }),
        name: "street1",
        placeholder: intl.formatMessage({
          defaultMessage: "ระบุที่อยู่"
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        className: classes.street0,
        hint: (
          <div
            style={{ textAlign: "end", color: "#696969", marginRight: "-14px" }}
          >{`${formik?.values?.street1?.length || 0}/80`}</div>
        ),
        maxLength: 80
      },
      {
        title: intl.formatMessage({ defaultMessage: "  " }),
        name: "street2",
        placeholder: intl.formatMessage({
          defaultMessage: "ระบุที่อยู่"
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 12,
        className: classes.street1,
        hint: (
          <div
            style={{
              textAlign: "end",
              color: "#696969",
              marginRight: "-14px",
              marginBottom: "-14px"
            }}
          >{`${formik?.values?.street2?.length || 0}/80`}</div>
        ),
        maxLength: 80
      },
      {
        title: isOtherCountry
          ? "City"
          : intl.formatMessage({ defaultMessage: "จังหวัด" }),
        name: "city",
        required: true,
        placeholder: cityPlaceHolder,
        type: isOtherCountry
          ? FIELD_TYPE.SINGLE_INPUT
          : FIELD_TYPE.SINGLE_SELECT,
        options: city,
        md: 6,
        isDisabled: isDisableFiled(city),
        maxLength: 40
      },
      {
        title: intl.formatMessage({ defaultMessage: "เขต/อำเภอ" }),
        name: "district",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือกเขต/อำเภอ"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: district,
        md: 6,
        isDisabled: isDisableFiled(district),
        hideField: isOtherCountry
      },
      {
        title: intl.formatMessage({ defaultMessage: "แขวง/ตำบล" }),
        name: "subDistrict",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือกแขวง/ตำบล"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: subDistrict,
        md: 6,
        isDisabled: isDisableFiled(subDistrict),
        hideField: isOtherCountry
      },

      {
        title: isOtherCountry
          ? "Postal Code"
          : intl.formatMessage({ defaultMessage: "รหัสไปรษณีย์" }),
        name: "postalCode",
        placeholder: postalCodePlaceHolder,
        type: isOtherCountry
          ? FIELD_TYPE.SINGLE_INPUT
          : FIELD_TYPE.SINGLE_SELECT,
        options: zipCode,
        md: 6,
        isDisabled: isOtherCountry ? false : isDisableFiled(selectedZipCode),
        maxLength: 10
      },
      { type: "Headers", title: "Communication" },
      {
        title: intl.formatMessage({ defaultMessage: "Language" }),
        name: "language",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: languageList,
        md: 3
      },

      {
        title: intl.formatMessage({ defaultMessage: "Mobile Number" }),
        name: "mobileNo",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 6,
        maxLength: 30
      },
      {
        title: intl.formatMessage({ defaultMessage: "Telephone No." }),
        name: "telephoneNo",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 4,
        maxLength: 30,
        className: classes.mobileFax
      },
      {
        title: intl.formatMessage({ defaultMessage: "Extension" }),
        name: "telephoneExtension",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.NUMBER_INPUT,
        md: 2,
        nonBold: true,
        maxLength: 5
      },
      {
        title: intl.formatMessage({ defaultMessage: "Fax" }),
        name: "faxNo",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.NUMBER_INPUT,
        md: 4,
        maxLength: 30,
        className: classes.mobileFax
      },
      {
        title: intl.formatMessage({ defaultMessage: "Extension" }),
        name: "faxNoExt",
        placeholder: intl.formatMessage({
          defaultMessage: " "
        }),
        type: FIELD_TYPE.NUMBER_INPUT,
        md: 2,
        nonBold: true,
        maxLength: 5
      },

      {
        title: isOtherCountry
          ? "Tax Number 1"
          : intl.formatMessage({
              defaultMessage: " เลขประจำตัวผู้เสียภาษี"
            }),
        titleInfo: !isOtherCountry
          ? intl.formatMessage({
              defaultMessage: "(13 หลัก)"
            })
          : null,
        name: isOtherCountry ? "taxNumber1" : "taxId",
        placeholder: isOtherCountry
          ? "Tax Number 1"
          : intl.formatMessage({
              defaultMessage: "Tax Number 3"
            }),
        type: isOtherCountry
          ? FIELD_TYPE.SINGLE_INPUT
          : FIELD_TYPE.NUMBER_INPUT,
        md: 6,
        maxLength: isOtherCountry ? 16 : 13,
        className: isOtherCountry ? null : classes.taxNumber
      },
      {
        title: isOtherCountry
          ? "Tax Number 2"
          : intl.formatMessage({ defaultMessage: " เลขที่สาขา" }),
        titleInfo: !isOtherCountry
          ? intl.formatMessage({ defaultMessage: "(5 หลัก)" })
          : null,
        name: isOtherCountry ? "taxNumber2" : "branchId",
        placeholder: isOtherCountry
          ? "Tax Number 2"
          : intl.formatMessage({
              defaultMessage: "Tax Number 4"
            }),
        type: isOtherCountry
          ? FIELD_TYPE.SINGLE_INPUT
          : FIELD_TYPE.NUMBER_INPUT,
        md: 6,
        maxLength: isOtherCountry ? 11 : 5,
        className: isOtherCountry ? null : classes.taxNumber
      }
    ],
    [subDistrict, district, city, zipCode, selectedZipCode]
  );

  return {
    formOneTimeShipTo,
    formOneTimeBillTo
  };
};

export default useOneTimeForms;
